@if ((virtualTour$ | async); as virtualTour) {
  <div class="accordeon-tab">
    <a [href]="virtualTour.data.attributes.url" target="_blank" class="accordeon-tab-label">
      <h2>{{ virtualTour.data.attributes.title | uppercase }}</h2>
    </a>
  </div>
}
